import { ProjectStore } from '@/types';
import StorableElementValues from '@/store/dataTransfertObject/StorableElementValues';
import { Route } from 'vue-router';
import appStateUpdator from '@/store/AppStateUpdator';

const projectInfoService = {
	updateProjectStore(storableElementValues: StorableElementValues) {
		appStateUpdator.updateProjectStore(storableElementValues);
	},

	deleteProjectStores() {
		appStateUpdator.deleteProjectStores();
	},

	getProjectStoreElement(storeToken: string, name: string) {
		const projectStore = this.getProjectStore(storeToken);

		if (null !== projectStore && Object.prototype.hasOwnProperty.call(projectStore, name)) {
			return projectStore[name];
		}
	},

	getProjectStore(storeToken: string) {
		const projectStores = appStateUpdator.getProjectStores() as ProjectStore[];
		const projectStore = projectStores.filter((projectStore) => (storeToken === projectStore.id)).shift();

		return projectStore || null;
	},

	isStored(storeToken: string, name: string) {
		const element = this.getProjectStoreElement(storeToken, name);

		return (undefined !== this.getProjectStoreElement(storeToken, name) && element && 0 !== element.length);
	},

	joinTokens(projectToken: string | null, route: Route) {
		const tokenToConcat = [];

		if (null !== projectToken) {
			tokenToConcat.push(projectToken);
		}

		if (undefined !== typeof route.name) {
			tokenToConcat.push(route.name);
		}

		return tokenToConcat.join('_');
	}
};

export default projectInfoService;
